export default __webpack_public_path__ + "static/media/risk-profile-vector.c8daa075.png";